export const employee = {
    labels: {
        role: "Cargo",
        sector: "Setor",
        registration_number: "Número de Matrícula",
        registration: "Matrícula",
        bond: "Vínculo",
        start_date: "Vínculo Início",
        end_date: "Vínculo Fim",
        ges_name: "GES Nome",
        ges_status: "GES Status",
        description: "Descrição",
        ges_description: "GES Descrição",
        social_name: "Nome Social",
        name: 'Nome',
        document: 'Documento',
        current: 'Atual',
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {},
};
